import { render, staticRenderFns } from "./LiveVerify.vue?vue&type=template&id=ab497c22&scoped=true"
import script from "./LiveVerify.vue?vue&type=script&lang=ts"
export * from "./LiveVerify.vue?vue&type=script&lang=ts"
import style0 from "./LiveVerify.vue?vue&type=style&index=0&id=ab497c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab497c22",
  null
  
)

export default component.exports